import React from "react";
import { ArrowRight, Building2 } from "lucide-react";
import SectionHeading from "@/components/site/SectionHeading";
import { CLIENTS, WHATSAPP_URL } from "@/lib/site";

export default function Clientes() {
  return (
    <>
      <section className="bg-white border-b border-surface-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-bronze">Clientes</div>
          <h1 className="mt-4 max-w-4xl font-display text-4xl font-black leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            Empresas que confiam na <span className="text-brand">Wellpec</span>.
          </h1>
          <p className="mt-6 max-w-3xl text-lg leading-relaxed text-ink-muted">
            Atendemos operadoras, prestadoras de serviço e empresas de energia com fornecimento técnico, rastreabilidade e agilidade comercial.
          </p>
        </div>
      </section>

      <section className="bg-surface-alt py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeading eyebrow="Carteira de clientes" title="Operações que já contam com a Wellpec." subtitle="Empresas de óleo, gás e energia atendidas em fornecimento de equipamentos, consumíveis e spare parts." />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {CLIENTS.map((client) => (
              <div key={client} className="flex items-center gap-4 rounded-lg border border-surface-line bg-white p-7 shadow-sm transition hover:-translate-y-1 hover:shadow-xl">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#eef1f2] text-brand">
                  <Building2 className="h-6 w-6" />
                </div>
                <span className="font-display text-xl font-bold text-ink">{client}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-brand-noise py-20 text-white">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="font-display text-3xl font-bold sm:text-4xl">Sua empresa também pode contar com a Wellpec.</h2>
          <p className="mx-auto mt-4 max-w-2xl text-white/80">Fale com nosso time comercial e conheça nosso portfólio de fornecimento técnico.</p>
          <a href={WHATSAPP_URL("Olá! Gostaria de conhecer o portfólio de fornecimento da Wellpec.")} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-4 font-semibold text-brand">
            Falar com o time comercial <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </section>
    </>
  );
}
